module.exports = __webpack_public_path__ + "static/media/galeryVinyl4.d1d66e6c.jpg";